export default "__VITE_ASSET__CEFxRcj9__"